// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recipesHeader{margin-bottom:1rem}.recipeRowItem{border-left:1px solid #503047;border-right:1px solid #503047}.recipeRowItem:nth-child(even){background-color:#f0f6f9}.recipeRowItem:nth-child(odd){background-color:#ebebeb}.recipeRowItem:hover{background-color:#ebf8ff;cursor:pointer;text-decoration:underline;color:#1c3144}", ""]);
// Exports
module.exports = exports;
